baseApp.service('IconsService', function(){
    return{
        getIcons : function(iconsType){
            switch(iconsType){
                default:
                    return {
                        key:"type",
                        values:{
                            "SITE": {
                                icon: "site",
                                caption: 'Site',
                            },
                            "ACCESSLOGIN": {
                                icon: "user",
                                caption: 'VPN User',
                            },
                            "GROUP": {
                                icon: "group",
                                caption: 'Group',
                            },
                            "SYSTEMGROUP": {
                                icon: "group",
                                caption: 'System Group',
                            },
                            "App": {
                                icon: "app",
                                caption: 'Application',
                            },
                            "CustomApp": {
                                icon: "app",
                                caption: 'Custom Application',
                            },
                            "AppCategory": {
                                icon: "category",
                                caption: 'Application Category',
                            },
                            "CustomCategory": {
                                icon: "category",
                                caption: 'Custom Category',
                            },
                            "Service": {
                                icon: "service",
                                caption: 'Service',
                            },
                            "CustomService": {
                                icon: "service",
                                caption: 'CustomService',
                            },
                            "URLFilter": {
                                icon: "search",
                                caption: 'URL Filtering Category',
                            },
                            "SUBNET": {
                                icon: "iprange",
                                caption: 'Subnet',
                            },
                            "HOSTSUBNET": {
                                icon: "host",
                                caption: 'Host',
                            },
                            "INTERFACEIPRANGE": {
                                icon: "iprange",
                                caption: 'Subnet',
                            },
                            "NETWORKINTERFACE": {
                                icon: "iprange",
                                caption: 'Network Interface',
                            },
                            "DIRECTORYSERVICEUSER": {
                                icon: "user",
                                caption: 'Directory Service User',
                            },
                            "FLOATINGIPSUBNET": {
                                icon: "floatingrange",
                                caption: 'Floating Range',
                            },
                            "CLOUDAPPLICATION": {
                                icon:"cloudApp",
                                caption: "Remote Access App"
                            },
                            "url": {
                                icon: "urlf-link",
                                caption: 'URL',
                            },
                            "tld": {
                                icon: "urlf-link",
                                caption: 'Top Level Domain',
                            },
                            "TLD": {
                                icon: "urlf-link",
                                caption: 'Top Level Domain',
                            },
                            "FQDN":  {
                                icon: "urlf-link",
                                caption: 'Fully Qualified Domain Name',
                            },
                            "category": {
                                icon: "category",
                                caption: 'Application Category',
                            },
                            "PORT": {
                                icon: "iprange",
                                caption: 'Ports',
                            },
                            "IpRange": {
                                icon: "iprange",
                                caption: 'IP Range',
                            },
                            "IP_RANGE": {
                                icon: "iprange",
                                caption: 'IP Range',
                            },
                            IP: {
                                icon: "iprange",
                                caption: 'IP Address',
                            },
                            "Location": {
                                icon: "category",
                                caption: 'Location',
                            },
                            "Country": {
                                icon: "category",
                                caption: 'Country',
                            },
                            "ASN": {
                                icon: "iprange",
                                caption: 'Remote ASN',
                            },
                            "PORT_PROTOCOL": {
                                icon: "iprange",
                                caption: 'Protocol/Port',
                            },
                        }
                    };
            }
        }
    };
});
